function initPricingCalc() {
    const pricingCalc = document.querySelector(".pricing-calculator");

    if (!pricingCalc) {
        return;
    }

    pricingCalc.dataset.inputData = JSON.stringify({
        employees: '1 - 100',
        editors: 1,
        viewers: 1,
        countries: {
            value: 1,
            price: 0,
        },
        extras: [],
        tier: '',
        total: 0,
    });

    const pricingCalcInputs = pricingCalc.querySelector(".pricing-calculator-inputs");
    const extrasInputs = pricingCalcInputs.querySelectorAll(".pricing-calculator-extras input");

    const editorsInput = pricingCalcInputs.querySelector("#editors");
    const viewersInput = pricingCalcInputs.querySelector("#viewers");
    const countriesInput = pricingCalcInputs.querySelector("#countries");

    const pricingCalcResultBasic = pricingCalc.querySelector(".pricing-result-basic");
    const pricingCalcResultExtended = pricingCalc.querySelector(".pricing-result-extended");
    const pricingCalcResultPremium = pricingCalc.querySelector(".pricing-result-premium");

    const basicBasePriceArray = pricingCalcInputs.dataset.basePricesBasic.split(',');
    const extendedBasePriceArray = pricingCalcInputs.dataset.basePricesExtended.split(',');
    const premiumBasePriceArray = pricingCalcInputs.dataset.basePricesPremium.split(',');

    const editorPrice = parseFloat(pricingCalcInputs.dataset.priceEditor);
    const viewerPrice = parseFloat(pricingCalcInputs.dataset.priceViewer);
    const countryPrice = parseFloat(pricingCalcInputs.dataset.priceCountry);

    let basicBasePrice = parseFloat(basicBasePriceArray[0]);
    let extendedBasePrice = parseFloat(extendedBasePriceArray[0]);
    let premiumBasePrice = parseFloat(premiumBasePriceArray[0]);

    let basicTotal = 0;
    let extendedTotal = 0;
    let premiumTotal = 0;

    let numOfEditors = 1;
    let numOfViewers = 1;
    let numOfCountries = 1;

    let basicExtrasTotal = 0;
    let extendedExtrasTotal = 0;
    let premiumExtrasTotal = 0;

    let dataForEmail = {
        employees: '1 - 100',
        editors: {
            value: 1,
            price: editorPrice * numOfEditors,
        },
        viewers: {
            value: 1,
            price: viewerPrice * numOfViewers,
        },
        countries: {
            value: 1,
            price: 0,
        },
        extras: [],
        tier: '',
        total: 0,
    };

    numOfEditors = parseInt(editorsInput.value);
    dataForEmail.editors = numOfEditors;

    numOfViewers = parseInt(viewersInput.value);
    dataForEmail.viewers = numOfViewers;

    numOfCountries = parseInt(countriesInput.value);
    dataForEmail.countries = {
        value: numOfCountries,
        price: (numOfCountries - 1) * countryPrice,
    };

    updateDataForEmail();

    initSlider();
    checkEditors();
    checkViewers();
    checkCountries();
    checkExtraServices();

    function initSlider() {
        const slider = document.getElementById("employeeRange");
        const outputContainer = document.querySelector("#sliderValue");
        const outputValue = outputContainer.querySelector(".numeric-value");

        const sliderValues = ['1 - 100', '101 - 500', '501 - ...'];
        const sliderPositions = ['16.666%', '50%', '83.333%'];

        outputValue.innerHTML = sliderValues[slider.value - 1]; // Display the default slider value

        // Update the current slider value (each time you drag the slider handle)
        slider.oninput = function () {
            /* Update slider value display */
            outputValue.innerHTML = sliderValues[slider.value - 1];
            outputContainer.style.left = sliderPositions[slider.value - 1];

            /* Base prices */
            basicBasePrice = parseFloat(basicBasePriceArray[slider.value - 1]);
            extendedBasePrice = parseFloat(extendedBasePriceArray[slider.value - 1]);
            premiumBasePrice = parseFloat(premiumBasePriceArray[slider.value - 1]);

            /* Update e-mail data */
            dataForEmail.employees = sliderValues[slider.value - 1];

            updatePrices();
            updateDataForEmail();
        }
    }

    function checkEditors() {
        editorsInput.addEventListener('change', () => {
            numOfEditors = parseInt(editorsInput.value);
            dataForEmail.editors = numOfEditors;
            updatePrices();
            updateDataForEmail();
        });
    }

    function checkViewers() {
        viewersInput.addEventListener('change', () => {
            numOfViewers = parseInt(viewersInput.value);
            dataForEmail.viewers = numOfViewers;
            updatePrices();
            updateDataForEmail();
        });
    }

    function checkCountries() {
        countriesInput.addEventListener('change', () => {
            numOfCountries = parseInt(countriesInput.value);
            dataForEmail.countries = {
                value: numOfCountries,
                price: (numOfCountries - 1) * countryPrice,
            };
            updatePrices();
            updateDataForEmail();
        });
    }

    function checkExtraServices() {
        extrasInputs.forEach((input) => {
            const inputPrice = parseFloat(input.value);
            const appliesTo = JSON.parse(input.dataset.appliesToTiers);

            input.addEventListener('change', () => {
                if (input.checked) {
                    appliesTo[0] ? basicExtrasTotal += inputPrice : null;
                    appliesTo[1] ? extendedExtrasTotal += inputPrice : null;
                    appliesTo[2] ? premiumExtrasTotal += inputPrice : null;

                    /* Add to e-mail data */
                    dataForEmail.extras.push(input.name + ' - ' + inputPrice + ' €');
                } else {
                    appliesTo[0] ? basicExtrasTotal -= inputPrice : null;
                    appliesTo[1] ? extendedExtrasTotal -= inputPrice : null;
                    appliesTo[2] ? premiumExtrasTotal -= inputPrice : null;

                    /* Remove from e-mail data */
                    const index = dataForEmail.extras.indexOf(input.name + ' - ' + inputPrice + ' €');
                    if (index > -1) {
                        dataForEmail.extras.splice(index, 1);
                    }
                }

                updatePrices();
                updateDataForEmail();
            });
        });
    }

    function updatePrices() {
        /* Update totals */
        basicTotal = calculateTotal(basicBasePrice);
        extendedTotal = calculateTotal(extendedBasePrice);
        premiumTotal = calculateTotal(premiumBasePrice);

        /* Add extras totals */
        basicTotal += basicExtrasTotal;
        extendedTotal += extendedExtrasTotal;
        premiumTotal += premiumExtrasTotal;

        pricingCalcResultBasic.innerHTML = basicTotal;
        pricingCalcResultExtended.innerHTML = extendedTotal;
        pricingCalcResultPremium.innerHTML = premiumTotal;
    }

    function updateDataForEmail() {
        pricingCalc.dataset.inputData = JSON.stringify(dataForEmail);
    }

    function calculateTotal(basePrice) {
        let outputPrice = basePrice;

        /* Add price per editor */
        outputPrice += (numOfEditors * editorPrice);

        /* Add price per viewer */
        outputPrice += (numOfViewers * viewerPrice);

        /* Add price per country */
        if (numOfCountries > 1) {
            outputPrice += ((numOfCountries - 1) * countryPrice);
        }

        return outputPrice;
    }
}

export default initPricingCalc;